import CallIcon from "@mui/icons-material/Call";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MailIcon from "@mui/icons-material/Mail";
import { Box, Container, Stack, TableRow, Typography } from "@mui/material";
import React, { useContext } from "react";
import AppLogo from "../../../assets/images/Trust-telecom-New-Logo.png";
import { AppContext } from "../../../lib/Context";
import {
  calculateEarlyTerminationCharge,
  calculateUpgradeCharge,
  calcultePackageAmount,
  checkIfPaygExists,
  checkIncludeDateFairUsage,
  checkPlatformUpradeSelected,
  checkSpeedAvailability,
  contractTerm,
  formatToTwoDecimals,
  getDataFairUsagePackagesName,
  renderAdditionalService,
  renderDiscountValidMonthsText,
  renderKeyPairsRows,
} from "../../../utils/helper";
import ContractTable from "./ContractTable";
import { useSelector } from "react-redux";

const headerFooterStyles = {
  position: "absolute",
  top: 0,
  left: 0,
  height: "inherit",
};

const thirdTableData = [
  { feature: "UK Landline Calls (01, 02, & 03)", details: "4p" },
  { feature: "Mobile Calls  (6 Major UK networks)", details: "16p" },
  {
    feature: "UK Landline Connection Charge",
    details: "18p",
  },
  {
    feature: "UK Mobile Connection Charge",
    details: "20p",
  },
];

const ContractPdf = () => {
  const {
    cliData,
    contractLength,
    downloadSpeed,
    uploadSpeed,
    routerValue,
    isReqDebitDetail,
    generalInfo,
    paperBillingPrice,
    calculateTotalRevenue,
    calculateOneOfCost,
    calculateGrossProfit,
    calculateOneOfCostProfit,
    cordedPhone,
    cordedlessPhone,
    equipments,
  } = useContext(AppContext);

  const { discount, discountDetails } = useSelector(
    (state) => state.discountReducer,
  );

  /**
   *check if any of the linevalues array in  cliData array contain payg
   *
   * @param {Array} cliData - The array from the cli data.
   */

  // usage
  const isIncludeDateFairUsageInLegacy = checkIncludeDateFairUsage(
    cliData,
    "legacyTariff",
    "legacy",
  );

  const isIncludeDateFairUsageInNgn = checkIncludeDateFairUsage(
    cliData,
    "digitalTariff",
    "ngnValue",
  );

  const dataFairUsagePackagesName = getDataFairUsagePackagesName(cliData);

  const isPaygExists = checkIfPaygExists(cliData);
  const isPlatformOptionSeleted = checkPlatformUpradeSelected(cliData);

  const totalOneOfCost = calculateOneOfCost();
  const totalRevenue = calculateTotalRevenue();
  const totalPlateFormUpgradeCharge =
    calculateUpgradeCharge(cliData)?.salePrice;

  const isDownloadSpeed = downloadSpeed.min > 0 && downloadSpeed.max;
  const isUploadSpeed = uploadSpeed.min > 0 && uploadSpeed.max;

  const renderTableDetailsForLegacy = (arg, bossIndex) => {
    const services = [
      arg?.lineValues[0]?.legacyService1,
      arg?.lineValues[0]?.legacyService2,
      arg?.lineValues[0]?.legacyService3,
      arg?.lineValues[0]?.legacyService4,
    ];

    const returnAkDamFinalPrice = () => {
      let finalPrice = Number(calcultePackageAmount(arg));

      if (bossIndex === 0 && routerValue.costType === "monthly") {
        finalPrice += Number(routerValue.price);
      }
      if (bossIndex === 0 && cordedPhone.costType === "monthly") {
        finalPrice += Number(cordedPhone.price);
      }
      if (bossIndex === 0 && cordedlessPhone.costType === "monthly") {
        finalPrice += Number(cordedlessPhone.price);
      }
      if (
        bossIndex === 0 &&
        equipments.costType === "monthly" &&
        equipments.price > 0
      ) {
        finalPrice += Number(equipments.price);
      }

      return formatToTwoDecimals(finalPrice);
    };

    const isRouterIncluded =
      routerValue.value > 0 &&
      routerValue.costType === "monthly" &&
      bossIndex === 0;

    return arg?.lineValues.slice(0, 1).map((item, index) => {
      let attachment = structuredClone(item.legacy.other);

      if (isRouterIncluded && attachment["Router"]) {
        delete attachment["Router"];
      } else {
        attachment = attachment;
      }

      return (
        <React.Fragment key={index}>
          {renderKeyPairsRows(attachment, isRouterIncluded)}
          {/* {renderSogeaCharges(arg.upgradeCharge)} */}
          <TableRow>
            <td
              className="table-cell"
              style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
            >
              Contract Term
            </td>
            <td
              className="table-cell"
              style={{ width: "50%", textAlign: "center" }}
            >
              {contractTerm(contractLength)}
            </td>
          </TableRow>

          {bossIndex === 0 &&
            routerValue.value > 0 &&
            routerValue.costType === "monthly" && (
              <TableRow>
                <td
                  className="table-cell"
                  style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
                >
                  {`${
                    routerValue.isUpgrade ? "Advanced " : ""
                  }Router – Configuration, Postage & Packaging`}
                </td>
                <td
                  className="table-cell"
                  style={{ width: "50%", textAlign: "center" }}
                >
                  Included
                </td>
              </TableRow>
            )}

          {bossIndex === 0 &&
            cordedPhone.value > 0 &&
            cordedPhone.costType === "monthly" && (
              <TableRow>
                <td
                  className="table-cell"
                  style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
                >
                  Corded Phone - Configuration, Postage & Packaging
                </td>
                <td
                  className="table-cell"
                  style={{ width: "50%", textAlign: "center" }}
                >
                  Included
                </td>
              </TableRow>
            )}

          {bossIndex === 0 &&
            cordedlessPhone.value > 0 &&
            cordedlessPhone.costType === "monthly" && (
              <TableRow>
                <td
                  className="table-cell"
                  style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
                >
                  Cordless Phone - Configuration, Postage & Packaging
                </td>
                <td
                  className="table-cell"
                  style={{ width: "50%", textAlign: "center" }}
                >
                  Included
                </td>
              </TableRow>
            )}

          {bossIndex === 0 &&
            equipments.value &&
            equipments.costType === "monthly" && (
              <TableRow>
                <td
                  className="table-cell"
                  style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
                >
                  {equipments?.name || equipments.value}
                </td>
                <td
                  className="table-cell"
                  style={{ width: "50%", textAlign: "center" }}
                >
                  Included
                </td>
              </TableRow>
            )}

          <TableRow>
            <td
              className="table-cell"
              style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
            >
              Tariff Rental{" "}
              {discountDetails
                ? renderDiscountValidMonthsText(discountDetails)
                : ""}
            </td>
            <td
              className="table-cell"
              style={{ width: "50%", textAlign: "center" }}
            >
              £{returnAkDamFinalPrice()} per month
            </td>
          </TableRow>

          {arg?.additionalService.isSelected &&
            renderAdditionalService(services, arg?.lineValues?.length)}
        </React.Fragment>
      );
    });
  };

  const renderTableDetailsForNgN = (mainOption, arg, bossIndex, junIndex) => {
    const services = [
      arg?.ngnService1,
      arg?.ngnService2,
      arg?.ngnService3,
      arg?.ngnService4,
    ];

    const returnFullAndFinalPrice = () => {
      let finalPrice = arg.ngnValue.salePrice;
      if (
        bossIndex === 0 &&
        junIndex === 0 &&
        routerValue.costType === "monthly"
      ) {
        finalPrice += Number(routerValue.price);
      }
      if (
        bossIndex === 0 &&
        junIndex === 0 &&
        cordedPhone.costType === "monthly"
      ) {
        finalPrice += Number(cordedPhone.price);
      }

      if (
        bossIndex === 0 &&
        junIndex === 0 &&
        cordedlessPhone.costType === "monthly"
      ) {
        finalPrice += Number(cordedlessPhone.price);
      }

      if (
        bossIndex === 0 &&
        junIndex === 0 &&
        equipments.costType === "monthly" &&
        equipments.price > 0
      ) {
        finalPrice += Number(equipments.price);
      }

      // Round to two decimal places
      return formatToTwoDecimals(finalPrice);
    };

    const isRouterIncluded =
      routerValue.value > 0 &&
      routerValue.costType === "monthly" &&
      bossIndex === 0 &&
      junIndex === 0;

    let attachment = structuredClone(arg?.ngnValue?.other);

    if (isRouterIncluded && attachment["Router"]) {
      delete attachment["Router"];
    } else if (isRouterIncluded && attachment["Router and Handset"]) {
      delete attachment["Router and Handset"];
    } else {
      attachment = attachment;
    }

    return (
      <React.Fragment>
        {renderKeyPairsRows(attachment)}
        {/* {renderSogeaCharges(mainOption.upgradeCharge)} */}

        <TableRow>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            Contract Term
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            {contractTerm(contractLength)}
          </td>
        </TableRow>

        {bossIndex === 0 &&
          junIndex === 0 &&
          routerValue.value > 0 &&
          routerValue.costType === "monthly" && (
            <TableRow>
              <td
                className="table-cell"
                style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
              >
                {`${
                  routerValue.isUpgrade ? "Advanced " : ""
                }Router – Configuration, Postage & Packaging`}
              </td>
              <td
                className="table-cell"
                style={{ width: "50%", textAlign: "center" }}
              >
                Included
              </td>
            </TableRow>
          )}

        {bossIndex === 0 &&
          junIndex === 0 &&
          cordedPhone.value > 0 &&
          cordedPhone.costType === "monthly" && (
            <TableRow>
              <td
                className="table-cell"
                style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
              >
                Corded Phone - Configuration, Postage & Packaging
              </td>
              <td
                className="table-cell"
                style={{ width: "50%", textAlign: "center" }}
              >
                Included
              </td>
            </TableRow>
          )}

        {bossIndex === 0 &&
          junIndex === 0 &&
          cordedlessPhone.value > 0 &&
          cordedlessPhone.costType === "monthly" && (
            <TableRow>
              <td
                className="table-cell"
                style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
              >
                Cordless Phone - Configuration, Postage & Packaging
              </td>
              <td
                className="table-cell"
                style={{ width: "50%", textAlign: "center" }}
              >
                Included
              </td>
            </TableRow>
          )}

        {bossIndex === 0 &&
          junIndex === 0 &&
          equipments.value &&
          equipments.costType === "monthly" && (
            <TableRow>
              <td
                className="table-cell"
                style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
              >
                {equipments?.name || equipments.value}
              </td>
              <td
                className="table-cell"
                style={{ width: "50%", textAlign: "center" }}
              >
                Included
              </td>
            </TableRow>
          )}

        <TableRow>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            Tariff Rental{" "}
            {discountDetails
              ? renderDiscountValidMonthsText(discountDetails)
              : ""}
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            £{returnFullAndFinalPrice()} per month
          </td>
        </TableRow>
        {mainOption.additionalService.isSelected &&
          renderAdditionalService(services, 0)}
      </React.Fragment>
    );
  };

  const renderSelectedService = () => {
    return cliData?.map((valll, mainIndex) => {
      if (
        valll?.legacyTariff?.isSelected === true &&
        valll?.lineValues[0]?.legacy?.value
      ) {
        let isIncludeDateFairUsage =
          valll?.lineValues[0]?.legacy?.includeDateFairUsage;
        let cliNumber = valll?.cliNumber ? valll?.mobileNo : "New Connection";
        let showHeader = `${cliNumber} ${"\u00A0\u00A0"} ${
          valll?.lineValues[0]?.legacy?.value
        }${isIncludeDateFairUsage ? "*" : ""} x ${valll?.lineValues?.length}`;
        return (
          <ContractTable
            key={mainIndex}
            primary={showHeader}
            secondary={"Details"}
            data={renderTableDetailsForLegacy(valll, mainIndex)}
          />
        );
      }
      if (valll?.digitalTariff?.isSelected === true) {
        return valll.lineValues?.map((itemm, index) => {
          let ngnValueName = itemm?.ngnValue?.value;
          let cliNumber = valll?.cliNumber ? valll?.mobileNo : "New Connection";
          let isIncludeDateFairUsage = itemm?.ngnValue?.includeDateFairUsage;

          if (ngnValueName) {
            return (
              <ContractTable
                key={index}
                primary={`${cliNumber} ${"\u00A0\u00A0"} Line ${
                  index + 1
                } : ${ngnValueName}${isIncludeDateFairUsage ? "*" : ""}`}
                secondary={"Details"}
                data={renderTableDetailsForNgN(valll, itemm, mainIndex, index)}
              />
            );
          }
        });
      }
    });
  };

  const secondTableData = [
    ...(routerValue?.value > 0 && routerValue.costType === "oneOfCost"
      ? [
          {
            feature: `${
              routerValue.isUpgrade ? "Advanced " : ""
            }Router – Configuration, Postage & Packaging`,
            details: `£${formatToTwoDecimals(routerValue.price)}`,
          },
        ]
      : []),

    ...(cordedPhone?.value > 0 && cordedPhone.costType === "oneOfCost"
      ? [
          {
            feature: "Corded Phone - Configuration, Postage & Packaging",
            details: `£${formatToTwoDecimals(cordedPhone.price)}`,
          },
        ]
      : []),

    ...(cordedlessPhone?.value > 0 && cordedlessPhone.costType === "oneOfCost"
      ? [
          {
            feature: "Cordless Phone - Configuration, Postage & Packaging",
            details: `£${formatToTwoDecimals(cordedlessPhone.price)}`,
          },
        ]
      : []),

    ...(isPlatformOptionSeleted
      ? [
          {
            feature: "Platform Upgrade Fee",
            details: `£${formatToTwoDecimals(totalPlateFormUpgradeCharge)}`,
          },
        ]
      : []),

    ...(equipments?.value.trim() !== "" && equipments?.costType === "oneOfCost"
      ? [
          {
            feature: equipments?.name || equipments.value,
            details: `£${formatToTwoDecimals(equipments.price)}`,
          },
        ]
      : []),

    {
      feature: "Early Termination Charge",
      // details: "£499",
      details: `£${calculateEarlyTerminationCharge(totalRevenue, contractLength)}`,
    },
  ];

  const fourthTableData = [
    ...(isDownloadSpeed
      ? [
          {
            feature: "Download",
            details: `${downloadSpeed.min} to ${downloadSpeed.max} Mbps`,
          },
        ]
      : []),
    ...(isUploadSpeed
      ? [
          {
            feature: "Upload",
            details: `${uploadSpeed.min} to ${uploadSpeed.max} Mbps`,
          },
        ]
      : []),
  ];

  const renderInstallatuionDetails = () => {
    return secondTableData.map((valll, index) => {
      return (
        <TableRow key={index}>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            {valll.feature}
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            {valll.details}
          </td>
        </TableRow>
      );
    });
  };

  const renderPaygValues = () => {
    return thirdTableData.map((valll, index) => {
      return (
        <TableRow key={index}>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            {valll.feature}
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            {valll.details}
          </td>
        </TableRow>
      );
    });
  };

  const renderUploadAndDownload = () => {
    return fourthTableData.map((valll, index) => {
      return (
        <TableRow key={index}>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            {valll.feature}
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            {valll.details}
          </td>
        </TableRow>
      );
    });
  };

  const renderAddHocServices = () => {
    if (isReqDebitDetail.no || generalInfo.eBilling == "No") {
      return (
        <>
          {generalInfo.eBilling == "No" && (
            <TableRow>
              <td
                className="table-cell"
                style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
              >
                Paper Billing Charges
              </td>
              <td
                className="table-cell"
                style={{ width: "50%", textAlign: "center" }}
              >
                £{paperBillingPrice.salePrice}
              </td>
            </TableRow>
          )}
          {isReqDebitDetail.no && (
            <TableRow>
              <td
                className="table-cell"
                style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
              >
                Payment Processing Fee
              </td>
              <td
                className="table-cell"
                style={{ width: "50%", textAlign: "center" }}
              >
                £7
              </td>
            </TableRow>
          )}
        </>
      );
    }
  };

  const renderTotalCharges = () => {
    return (
      <>
        <TableRow>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            One-off Cost
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            £{formatToTwoDecimals(totalOneOfCost)}
          </td>
        </TableRow>
        <TableRow>
          <td
            className="table-cell"
            style={{ borderRight: "2px solid #c3c1c1", width: "50%" }}
          >
            Monthly Cost{" "}
          </td>
          <td
            className="table-cell"
            style={{ width: "50%", textAlign: "center" }}
          >
            £{formatToTwoDecimals(totalRevenue)}
          </td>
        </TableRow>
      </>
    );
  };

  return (
    <Container maxWidth="lg">
      <Box bgcolor="#726c60" height={65} position="relative">
        <Box
          bgcolor="primary.main"
          sx={{
            ...headerFooterStyles,
            width: "150px",
            zIndex: 99,
            clipPath: "polygon(0 -2%, 0% 300%, 100% 0)",
          }}
        />
        <Box
          bgcolor="secondary.light"
          sx={{
            ...headerFooterStyles,
            width: "190px",
            clipPath: "polygon(0 -11%, 0% 400%, 100% 0)",
          }}
        />
      </Box>

      <Stack
        mt={3}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box width={{ xs: 120, md: 240 }}>
          <img src={AppLogo} width={"100%"} alt="App Logo" />
        </Box>
        <Stack alignItems={"center"}>
          <Typography>167-169 Great Portland Street,</Typography>
          <Typography>5th Floor, London, England, W1W 5PF</Typography>
          <Typography>Email: support@trust-business.co.uk</Typography>
          <Typography>Support Number - 0207 629 9888 </Typography>
          <Typography>Company Number - 15994771 </Typography>
          <Typography>VAT no. 482386855 </Typography>
        </Stack>
      </Stack>

      <Typography
        variant="h4"
        textAlign="center"
        borderBottom="2px solid black"
        display="table"
        margin="auto"
        fontWeight={500}
      >
        Contract Summary
      </Typography>

      <Typography my={2} variant="body1" fontSize="1.125rem">
        Dear {`${generalInfo.title} ${generalInfo.name}`}
      </Typography>

      <Typography my={2} variant="body1" fontSize="1.125rem">
        Please find enclosed a detailed breakdown of your preferred tariff.
      </Typography>
      {/* contract Table */}
      <Stack spacing={1}>
        {renderSelectedService()}

        <ContractTable
          primary={"Hardware, Installation, Early Termination"}
          secondary={"One-off Costs"}
          data={renderInstallatuionDetails()}
        />

        {isPaygExists && (
          <ContractTable
            primary={"PAYG Call Charges"}
            secondary={"Sale Price"}
            data={renderPaygValues()}
          />
        )}

        {(isDownloadSpeed || isUploadSpeed) && (
          <ContractTable
            primary={"Internet Data"}
            secondary={"Speed Range"}
            data={renderUploadAndDownload()}
          />
        )}

        {(isReqDebitDetail.no || generalInfo.eBilling == "No") && (
          <ContractTable
            primary={"Ad hoc Services/Charges"}
            secondary={"Sale Price"}
            data={renderAddHocServices()}
          />
        )}

        <ContractTable
          primary={"Pricing Breakdown"}
          secondary={"Total Amount"}
          data={renderTotalCharges()}
        />
      </Stack>
      {/* contract Table */}
      <Typography my={2} variant="body1" fontSize="1.125rem">
        Trust Business will not automatically renew your contract term or
        increase the cost of your tariff after the initial contract period. Your
        service will continue without interruption. You will be notified 30 days
        in advance of any future price increases and have the right to cancel
        without penalty during that period. All prices exclude VAT.
      </Typography>

      <Typography my={2} variant="body1" fontSize="1.125rem">
        {/* If there is a recurring and continuous discrepancy between actual and
        contracted internet performance, you are entitled to cancel free of
        charge.
         */}
        The Business Assurance and Care Level 2 package is automatically added
        from month three at a recurring charge of £5 per month per Premises
        unless the Customer opts out.
      </Typography>
      <Typography my={2} variant="body1" fontSize="1.125rem">
        If your Broadband Service regularly and continuously falls below the
        speed range shown above, as measured at the router rather than over
        Wi-Fi, you must report it and allow us a reasonable opportunity to
        investigate and fix it. If it cannot be fixed, you may cancel the
        affected Broadband Service without an Early Termination Charge, but no
        compensation or retrospective refund will be payable.{" "}
        {isIncludeDateFairUsageInLegacy || isIncludeDateFairUsageInNgn
          ? `${dataFairUsagePackagesName.join(", ")} is subject to a *fair usage policy of 400 GB per month. Data used outside of this allowance is charged at 3p per MB.`
          : ""}
      </Typography>

      <Typography my={2} variant="body1" fontSize="1.125rem">
        Find our Terms and Conditions, including complaints procedure, attached.
      </Typography>

      <Stack alignItems="flex-end" spacing={1} mt={15} pr={2}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="h6" fontSize="1.125rem" lineHeight="normal">
            167-169 Great Portland Street, 5th Floor, London, England, W1W 5PF
          </Typography>
          <LocationOnIcon sx={{ color: "primary.main" }} />
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="h6" fontSize="1.125rem" lineHeight="normal">
            0207 629 9888
          </Typography>
          <CallIcon sx={{ color: "primary.main" }} />
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="h6" fontSize="1.125rem" lineHeight="normal">
            support@trust-business.co.uk
          </Typography>
          <MailIcon sx={{ color: "primary.main" }} />
        </Stack>
      </Stack>

      <Box
        mt={4}
        bgcolor="#726c60"
        height={65}
        position="relative"
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          bgcolor="primary.main"
          sx={{
            ...headerFooterStyles,
            width: "150px",
            zIndex: 9999,
            clipPath: "polygon(0 -2%, 0% 300%, 100% 0)",
          }}
        />
        <Box
          bgcolor="secondary.light"
          sx={{
            ...headerFooterStyles,
            width: "190px",
            clipPath: "polygon(0 -11%, 0% 400%, 100% 0)",
          }}
        />
        <Typography variant="h6" textAlign={"center"} color={"secondary.light"}>
          www.trust-business.co.uk
        </Typography>
      </Box>
    </Container>
  );
};

export default ContractPdf;
